import React, { useState } from 'react';
import '../CSS/Finance&Accounting.css';

const FinanceAccounting: React.FC = () => {
  const [activeCard, setActiveCard] = useState('fraud-protection');

  const toggleCard = (cardId: string) => {
    setActiveCard(cardId);
  };

  return (
    <div className="finance-accounting-page">
      {/* Banner Section */}
      <div className="finance_banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Finance & Accounting</h1>
        </div>
      </div>

      {/* Collapsible Cards Section */}
      <div className="finance_collapsibles">
        <div className="collapsibles-intro">
          <p>We help companies transform their financial services with emerging technological solutions for improved operational efficiency, greater transparency, faster response times and better customer experience.</p>
        </div>
        
        <div className="collapsible-cards">
          <div 
            className={`collapsible-card ${activeCard === 'fraud-protection' ? 'active' : ''}`}
            onClick={() => toggleCard('fraud-protection')}
          >
            <div className="card-header">
              <div className="card-icon">
                <img src="/Assets/Icons/automated-payment-fraud-protection-icon.svg" alt="Fraud Protection" />
              </div>
              <div className="card-title">
                <span>Automated Payment Fraud Protection</span>
                <div className="card-arrow">
                  <img 
                    src={activeCard === 'fraud-protection' ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt={activeCard === 'fraud-protection' ? "Expanded" : "Collapsed"} 
                  />
                </div>
              </div>
            </div>
            {activeCard === 'fraud-protection' && (
              <div className="card-content">
                <p>Trustmi delivers a centralized, fully automated solution that safeguards the entire B2B payment lifecycle, proactively addressing the root cause of financial fraud - socially engineered cyberattacks - while reducing manual effort and errors.</p>
              </div>
            )}
          </div>

          <div 
            className={`collapsible-card ${activeCard === 'data-correlation' ? 'active' : ''}`}
            onClick={() => toggleCard('data-correlation')}
          >
            <div className="card-header">
              <div className="card-icon">
                <img src="/Assets/Icons/real-time-data-correlation-icon.svg" alt="Data Correlation" />
              </div>
              <div className="card-title">
                <span>Real-Time Data Correlation</span>
                <div className="card-arrow">
                  <img 
                    src={activeCard === 'data-correlation' ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt={activeCard === 'data-correlation' ? "Expanded" : "Collapsed"} 
                  />
                </div>
              </div>
            </div>
            {activeCard === 'data-correlation' && (
              <div className="card-content">
                <p>Trustmi pulls data from various financial systems and combines it with other critical data points to validate transactions in real time, stopping fraud attempts stemming from social engineering before they cause harm.</p>
              </div>
            )}
          </div>

          <div 
            className={`collapsible-card ${activeCard === 'behavioral-ai' ? 'active' : ''}`}
            onClick={() => toggleCard('behavioral-ai')}
          >
            <div className="card-header">
              <div className="card-icon">
                <img src="/Assets/Icons/comprehensive-behavioral-ai-icon.svg" alt="Behavioral AI" />
              </div>
              <div className="card-title">
                <span>Comprehensive Behavioral AI</span>
                <div className="card-arrow">
                  <img 
                    src={activeCard === 'behavioral-ai' ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt={activeCard === 'behavioral-ai' ? "Expanded" : "Collapsed"} 
                  />
                </div>
              </div>
            </div>
            {activeCard === 'behavioral-ai' && (
              <div className="card-content">
                <p>Trustmi analyzes patters accross vendors, payment data, emails, and financial documents, detecting sophiscated social engineering tactics and ensuring holistic fraud detection beyond limited channels.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Finance Pairing Section - Desktop */}
      <div className="finance_pairing desktop-finance-pairing">
        <div className="finance_pairing-content">
          {/* Section 1: Agentic AI Solutions - Image Right */}
          <div className="finance_image_right">
            <div className="section-image">
              <img src="/Assets/Finance & Accounting/agentic-ai-solutions-section-image.png" alt="Agentic AI Solutions" />
            </div>
            <div className="finance_section_text">
              <h2 className="finance_section_title">Agentic AI Solutions for <span className="gradient-text">Financial operations</span></h2>
              <p className="section-description">We help customers to build agentic AI solutions and integrate them with their financial management applications that help financial institutions in smarter decision-making and improve user engagement.</p>
            </div>
          </div>

          {/* Section 2: Intelligent CRM Solutions - Image Left */}
          <div className="finance_image_left">
            <div className="section-image">
              <img src="/Assets/Finance & Accounting/intelligent-crm-solutions-section-image.png" alt="Intelligent CRM Solutions" />
            </div>
            <div className="finance_section_text">
              <h2 className="finance_section_title">Intelligent CRM Solutions</h2>
              <p className="section-description">We integrate cloud-enabled CRM systems with the latest technologies, including microservices, voice technology and AI for better financial management.</p>
            </div>
          </div>

          {/* Section 3: Robotic Process Automation - Image Left */}
          <div className="finance_image_right">
            <div className="section-image">
              <img src="/Assets/Finance & Accounting/robotic-process-automation-section-image.png" alt="Robotic Process Automation" />
            </div>
            <div className="finance_section_text">
              <h2 className="finance_section_title">Robotic Process Automation</h2>
              <p className="section-description">We develop RPA bots for financial companies to take over the labor-intensive financial processes and enhance the productivity of employees.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Finance Pairing Section - Mobile (480px) */}
      <div className="finance_pairing mobile-finance-pairing">
        <div className="finance_pairing-content">
          {/* Section 1: Agentic AI Solutions - Text Above Image */}
          <div className="mobile-finance-section">
            <div className="mobile-finance-text">
              <h2 className="mobile-finance-title">Agentic AI Solutions for <span className="gradient-text">Financial operations</span></h2>
              <p className="mobile-finance-description">We help customers to build agentic AI solutions and integrate them with their financial management applications that help financial institutions in smarter decision-making and improve user engagement.</p>
            </div>
            <div className="mobile-finance-image">
              <img src="/Assets/Finance & Accounting/agentic-ai-solutions-section-image.png" alt="Agentic AI Solutions" />
            </div>
          </div>

          {/* Section 2: Intelligent CRM Solutions - Text Above Image */}
          <div className="mobile-finance-section">
            <div className="mobile-finance-text">
              <h2 className="mobile-finance-title">Intelligent CRM Solutions</h2>
              <p className="mobile-finance-description">We integrate cloud-enabled CRM systems with the latest technologies, including microservices, voice technology and AI for better financial management.</p>
            </div>
            <div className="mobile-finance-image">
              <img src="/Assets/Finance & Accounting/intelligent-crm-solutions-section-image.png" alt="Intelligent CRM Solutions" />
            </div>
          </div>

          {/* Section 3: Robotic Process Automation - Text Above Image */}
          <div className="mobile-finance-section">
            <div className="mobile-finance-text">
              <h2 className="mobile-finance-title">Robotic Process Automation</h2>
              <p className="mobile-finance-description">We develop RPA bots for financial companies to take over the labor-intensive financial processes and enhance the productivity of employees.</p>
            </div>
            <div className="mobile-finance-image">
              <img src="/Assets/Finance & Accounting/robotic-process-automation-section-image.png" alt="Robotic Process Automation" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinanceAccounting; 